const serviceUrl = `${__configuration.apiUrl}/massia/cessions`;

export default class CessionsService {
	static $inject = ['$http'];

	constructor($http) {
		this.$http = $http;
	}

	async getSocietesCom() {
		let url = `${__configuration.apiUrl}/massia/societes-commerciales`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getSitesCom(pIdSociete) {
		let url = `${__configuration.apiUrl}/massia/sites-commerciaux/header/${pIdSociete}`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getCessionAutorise() {
		let url = `${__configuration.apiUrl}/massia/cessions`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async createAutoriseCession(idSiteEmetteur, idSiteDeReception) {
		let url = `${__configuration.apiUrl}/massia/cessions`;
		const data = {
			idSiteEmetteur: idSiteEmetteur,
			idSiteReceveur: idSiteDeReception,
			libelleSiteEmetteur: '',
			libelleSiteReceveur: ''
		};
		const result = await this.$http.post(url, data);
		return result;
	}

	async deleteAutoriseCession(id) {
		let url = `${serviceUrl}/${id}`;
		return this.$http.delete(url);
	}
}
